import React, { createContext, useContext, useCallback } from 'react'
import { sendSportsbookStatusEvent } from '../utils/mobileAppFunctionality'
import { EnvConfig } from '../config/EnvConfig'
import { useGroowthbookLocaleFeature } from '../hooks/useGrowthbook'
import { useOpenBetsState } from '../hooks/useOpenBetsState'
import { usePolling } from '../hooks/usePolling'
import { isBrowser } from '../utils/generic'
import { getOpenBetsCount } from '../adapters/kambi'

const OpenBetsContext = createContext()

export const OpenBetsProvider = ({ children }) => {
  const isSportsEnabled = useGroowthbookLocaleFeature('fe_igp_sports_enabled')

  const openBetsState = useOpenBetsState({ isSportsEnabled, skipInitialFetch: true })

  const {
    openBetsCount,
    isLoading,
    error,
    isInitialized,
    refreshOpenBetsCount,
  } = openBetsState

  const pollingCallback = useCallback(async () => {
    const response = await getOpenBetsCount()

    if (!response.ok) {
      return
    }

    sendSportsbookStatusEvent(response.data)
  }, [])

  const shouldPoll = isSportsEnabled && isBrowser()

  usePolling(
    shouldPoll,
    pollingCallback,
    EnvConfig.OPEN_BETS_POLLING_INTERVAL
  )

  return (
    <OpenBetsContext.Provider value={{
      openBetsCount,
      isLoading,
      error,
      isInitialized,
      refreshOpenBetsCount,
    }}>
      {children}
    </OpenBetsContext.Provider>
  )
}

export const useOpenBets = () => {
  const context = useContext(OpenBetsContext)
  if (!context) {
    throw new Error('useOpenBets must be used within an OpenBetsProvider')
  }
  return context
}
